import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { cn } from '@/helpers/tailwind'

const InfoBox = ({
  className = '',
  panelClassName = '',
  children,
  size = 'medium',
}: {
  className?: string
  panelClassName?: string
  children: React.ReactNode
  size?: 'small' | 'medium'
}) => {
  return (
    <Popover className={`inline ${className}`}>
      <PopoverButton className="relative z-0 cursor-pointer focus:outline-none">
        <InformationCircleIcon className={cn(size === 'medium' ? 'size-5' : 'size-4', 'relative -top-1')} />
      </PopoverButton>

      <PopoverPanel
        className={`absolute z-10 mx-5 rounded-xl border-2 border-selphTeal-400 bg-selphTeal-100 px-4 py-4 text-left text-base shadow-2xl ${panelClassName}`}
      >
        {children}
      </PopoverPanel>
    </Popover>
  )
}

export default InfoBox
